import { useCallback, useState } from 'react';
import { useQuery } from "@tanstack/react-query";

import { FieldValues } from 'react-hook-form';


import FormWrapper15620 from "./Form15620/FormWrapper15620";


import PublicHeader from "../../components/PublicHeader/PublicHeader";
import DocumentGeneration from "../../components/DocumentGeneration/DocumentGeneration";
import { getYupDynamicScheme } from "../../components/DocumentGeneration/helpers/yupValidationHelpers";

import { TemplatesService } from "./TemplateService";
import SelectForm83bType from '../../components/SelectForm83bType/SelectForm83bType';


function getFormDataFromStorage() {

    const formData = sessionStorage.getItem('processing');
    return formData ? JSON.parse(formData) : null;
}

const PublicFile83b = () => {
    const [inputValue, setInputValue] = useState('');
    const [isSupposeExists, setSuppose] = useState(false);

    const [isRegularForm, setRegularForm] = useState<boolean>(() => {
        const formData = getFormDataFromStorage();
        return formData ? formData.isRegular : true;
    });
    
    const [isFormTypeSelected, setFormTypeSelected] = useState(() => {
        const formData = getFormDataFromStorage();
        return Boolean(formData);
    });


     const { data: initialInfo } = useQuery({
        queryKey: TemplatesService.fetchInitialInfo.queryKey,
        queryFn: () => TemplatesService.fetchInitialInfo.queryFn(),
    });
    const { templateCode, templateSpouseCode, price, uspsPrice, templateCrypto } = initialInfo || {};
    const template = isSupposeExists
        ? templateSpouseCode
        : templateCode;

    const { data: fieldsConfiguration, isLoading: requiredFieldsLoading } = useQuery({
        queryKey: [...TemplatesService.fetchTemplateConfiguration.queryKey, isSupposeExists],
        queryFn: () => TemplatesService.fetchTemplateConfiguration.queryFn(template),
        enabled: Boolean(templateCode) && Boolean(templateSpouseCode),
        gcTime: 0,
    });

    const { data: docAsHtml, isLoading: docAsHtmlLoading } = useQuery({
        queryKey: [...TemplatesService.exportDocAsHtml.queryKey, isSupposeExists],
        queryFn: () => TemplatesService.exportDocAsHtml.queryFn(template),
        enabled: Boolean(templateCode) && Boolean(templateSpouseCode),
        gcTime: 0,
    });

    const formSchema = fieldsConfiguration?.configs ? getYupDynamicScheme(fieldsConfiguration?.configs) : undefined;

    const handleAddEmail = useCallback((formData: FieldValues) => {
        setInputValue(formData.email);
        setFormTypeSelected(true);
    }, []);

    return (
        <div className="h-full max-w-full surface-100 flex flex-column">
            <PublicHeader />
            {
                isFormTypeSelected ? (
                    isRegularForm ? (
                        <>
                            <DocumentGeneration
                                isSupposeExists={isSupposeExists}
                                setSuppose={setSuppose}
                                template={template}
                                data={fieldsConfiguration}
                                requiredFieldsLoading={requiredFieldsLoading}
                                docAsHtml={docAsHtml}
                                docAsHtmlLoading={docAsHtmlLoading}
                                isPublic
                                price={price}
                                uspsPrice={uspsPrice}
                                showSelectTemplate={Boolean(templateSpouseCode)}
                                formSchema={formSchema}
                                showDeliveryService={true}
                            />
                        </>
                    ) : (
                        <FormWrapper15620

                            price={price}
                            uspsPrice={uspsPrice}
                            isPublic={true}
                            email={inputValue}
                            isDataLoaded={true}
                            templateId={templateCrypto}
                            isPublicOpenAi={false}
                            paymentEnabled={true} deliveryService={''} />
                    )
                ) : (
                    <SelectForm83bType
                        isPublic={true}
                        onSelectHandler={setRegularForm}
                        selectedForm={isRegularForm}
                        handleAddEmail={handleAddEmail}
                        setFormTypeSelected={setFormTypeSelected} />
                )
            }

        </div>
    );

}

export default PublicFile83b;
